<template>
    <div class="common-footer-info">
        <div class="common-footer-info__column">
            <span v-html="disclaim"/><br />
        </div>
        <div class="common-footer-info__column">
            <span v-html="complaintInfo"/><br />
            <span v-text="companyJurAddress"/><br />
            <span v-text="companyEmail"/><br />
        </div>
        <p class="common-footer-info__address">
            ООО «СИМПЛ ЭСТЭЙТ», ИНН 7707430579,<br /> ОГРН 1197746322289,
            117342, г.&nbsp;Москва, ул.&nbsp;Бутлерова, д.&nbsp;17, эт/комн&nbsp;5/248
        </p>
<!--        <span v-text="companyName"/><br />-->
<!--        <span v-text="companyTin"/><br />-->
<!--        <span v-text="companyOgrn"/><br />-->
    </div>
</template>

<script>
export default {
    name: 'common-footer-info',
    computed: {
        contacts() {
            return this.$store.getters['site/contacts'];
        },
        company() {
            return this.$store.getters['site/company'];
        },
        disclaim() {
            return 'Предложение не является индивидуальной инвестиционной рекомендацией. Заключение с использованием инвестиционной платформы договоров, по которым привлекаются инвестиции, является высокорискованным и может привести к потере инвестированных денежных средств в полном объеме (пп. 2 п. 5.2. ст. 28 ФЗ «О&nbsp;рекламе»).';
        },
        complaintInfo() {
            return 'Направить жалобу или обращение возможно следующими способами:';
        },
        companyJurAddress() {
            return `По юридическому адресу ${this.company.type} «${this.company.name}» - ${this.company.jur_address}`;
        },
        companyEmail() {
            return 'По адресу электронной почты help@simpleestate.ru';
        },
        // companyName() {
        //     return `${this.company.type} «${this.company.name}»`;
        // },
        // companyTin() {
        //     return `ИНН: ${this.company.tin}`;
        // },
        // companyOgrn() {
        //     return `ОГРН: ${this.company.ogrn}`;
        // },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.common-footer-info {
    .typography-body();

    margin-top: 16px;

    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: @grid-gap;

    &__column {
        flex-shrink: 0;
    }
    &__address {
        grid-column: span 2;
    }

    @media @media-xl-down {
        grid-template-columns: 1fr;

        &__address {
            grid-column: span 1;
        }
    }
}
</style>
